import { useNavigate } from "react-router-dom";
import { PageHeader } from "../components/ui/card.js";
import { JobCreateForm } from "../components/jobs/jobCreateForm.js";
import { useCatalogOptions } from "../lib/useCatalogOptions.js";
import { useI18n } from "../i18n/index.js";

export function JobCreatePage() {
  const navigate = useNavigate();
  const catalog = useCatalogOptions();
  const { t } = useI18n();

  return (
    <>
      <PageHeader title={t("jobs.newJob")} description={t("jobs.create.description")} />
      <JobCreateForm
        catalog={catalog}
        onCreated={(job) => navigate(`/jobs/${job.id}`)}
        onCancel={() => navigate("/jobs")}
      />
    </>
  );
}
